export default __webpack_public_path__ + "static/Overtake_Logo_KO-5f6f0a0b7741f772e567de972ff52a67.png";